<template>
  <v-dialog
      v-model="showDialog"
      max-width="800px"
      persistent
      scrollable
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Tourstatus</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="8">
              <v-text-field
                  label="Name"
                  v-model="tour.task_name"
                  disabled
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  label="Zieldatum"
                  v-model="tour.till"
                  disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-data-table
              :headers="headers"
              :items="tour_data"
              item-key="id"
              class="elevation-1"
              :items-per-page="10"
          >
            <!--template v-slot:footer.prepend>
              <v-btn
                  icon
                  color=""
                  @click="openMap"
              >
                <v-icon>mdi-map</v-icon>
              </v-btn>
            </template-->
            <template v-slot:item.completed="{ item }">
              <v-chip v-if="item.completed !== ''"
                  color="green"
                  dark
              >
                {{ 'Fertig' }}
              </v-chip>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false; $emit('cancel')"
        >
          Abbrechen
        </v-btn>
      </v-card-actions>
    </v-card>
    <task-map ref="task_map" @close-map="" ></task-map>

  </v-dialog>

</template>

<script>
import Planning_map  from "@/views/planning/planning_map.vue";

export default {
  name: "TourOverviewDialog",
  components: {
    TaskMap: Planning_map,
  },
  props: {
    tour: {
      type: Object,
      default: () => {
        return {
          id: '',
          task_name: '',
          task_description: '',
          till: "02.04.2025",
        }
      },
    },
    tour_data: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      showDialog: false,
      error: false,
      headers: [
        {
          text: 'Teilaufgabe',
          align: 'start',
          value: 'subject',
        },
        { text: 'Anz. Planungen', value: 'planned' },
        { text: 'Anz. Erledigt', value: 'finished' },
        { text: 'Fertiggestellt', value: 'completed' },
      ],
    }
  },

  watch: {

  },
  methods: {
    openMap() {
      //this.$refs.task_map.showMap(this.tour_data);
    },
    show() {
      if (this.showDialog) {
        return;
      }

      this.showDialog = true;
    },
  }

}
</script>

<style scoped>
  ::v-deep .theme--light.v-input--is-disabled input {
    color: rgba(0, 0, 0, 0.87);
  }

  ::v-deep .theme--light.v-input--is-disabled textarea {
    color: rgba(0, 0, 0, 0.87);
  }
</style>
